// Core Vue & Libraries
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './lang'
import store from './store'

// Plugins
import VueAxios from 'vue-axios'
import VueClipboard from 'vue-clipboard2'
import VueCurrencyFilter from 'vue-currency-filter'
import VueMoment from 'vue-moment'
import VueNotification from 'vue-notification'
import VueTour from 'vue-tour'

// Utils
import request from './utils/request'
import * as filters from './filters'
import mixpanel from '@/utils/mixpanel'
import freshdesk from '@/utils/freshdesk'
import events from '@/utils/events'

// Global Styles & Bootstrap Overrides
import '@/assets/scss/main.scss'
import '@/utils/bootstrapImports'
import '@/utils/gtm'
import '@/utils/sentry'
// Configure Validation
import '@/utils/veeValidate'

// Configure Clipboard
VueClipboard.config.autoSetContainer = true

// Register Plugins
Vue.use(VueAxios, request)
Vue.use(VueClipboard)
Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: ',',
  fractionCount: 0,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false
})
Vue.use(VueMoment)
Vue.use(VueNotification)
Vue.use(VueTour)

Vue.router = router

Vue.use(mixpanel, {
  token: process.env.VUE_APP_RF_MIXPANEL_TOKEN || 'dummy-token' // doesn't break the product
})

Vue.use(events)
Vue.use(freshdesk)

// Register Global Filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

// Buses
export const uploadFilesBus = new Vue()
export const invoiceBus = new Vue()

export default new Vue({
  render: (h) => h(App),
  router,
  i18n,
  store
}).$mount('#app')
